export default "__VITE_ASSET__DirKKfi5__"